import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import {
  addToFavoriteItems,
  addToFavoriteItemsFailed,
  addToFavoriteItemsSuccess,
  favoriteItemsList,
  favoriteItemsListFailed,
  favoriteItemsListSuccess,
  removeFromFavoriteList,
  removeFromFavoriteListFailed,
  removeFromFavoriteListSuccess,
} from './slice';
import * as endpoints from './endpoints';
import { getFavoriteItems } from './selectors';

function* favoriteItemsListSaga(): any {
  try {
    const response = yield call(request.get, endpoints.getFavorite);
    yield put(favoriteItemsListSuccess(response.data));
  } catch (error: any) {
    yield put(favoriteItemsListFailed(error));
  }
}

function* addToFavoriteItemsSaga({ payload }: ReturnType<typeof addToFavoriteItems>): any {
  const { uri } = payload;
  try {
    const response = yield call(request.post, endpoints.addFavorite, { uri: uri });

    let { data: favoriteList } = yield select(getFavoriteItems);
    if (!favoriteList) {
      favoriteList = [];
    }
    const favoriteItems = [response.data, ...favoriteList];
    yield put(addToFavoriteItemsSuccess(favoriteItems));
  } catch (error: any) {
    yield put(addToFavoriteItemsFailed(error));
  }
}

function* removeFromFavoriteListSaga({ payload }: ReturnType<typeof removeFromFavoriteList>): any {
  const { uri } = payload;

  try {
    const response = yield call(request.post, endpoints.deleteFavorite, { uri: uri });

    const { data: favoriteList } = yield select(getFavoriteItems);
    if (favoriteList) {
      const favoriteItems = favoriteList.filter((item: any) => item.uri !== uri);
      yield put(removeFromFavoriteListSuccess(favoriteItems));
    }
  } catch (error: any) {
    yield put(removeFromFavoriteListFailed(error));
  }
}

function* favoriteScreenSagas() {
  yield all([takeLatest(favoriteItemsList, favoriteItemsListSaga)]);
  yield all([takeEvery(addToFavoriteItems, addToFavoriteItemsSaga)]);
  yield all([takeEvery(removeFromFavoriteList, removeFromFavoriteListSaga)]);
}
export { favoriteScreenSagas, favoriteItemsListSaga };
